import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import Status from "components/Status/Status";

interface Props extends MultiPickerListProps<server.dto.StatusSmall> {
  mainArea: server.dto.MainAreas;
}
const perPage = 20;

const MultiStatusList = (props: Props) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedStatusInstruction>({
    keyword: "",
    page: 1,
    perPage: perPage,
    mainArea: props.mainArea
  });

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="statuslist"
      api={window.CoreApi.Status.Paginated}

      getError={() => undefined}
      excludeKeys={props.excludeKeys}

      renderListItem={(s) => <Status status={s} />}

      onChange={props.onChange}
      getId={(s) => s.statusId}
      getLabel={(s) => <Status status={s} />}
      value={props.value}
    />
  </>;
};

export default MultiStatusList;